<template>
  <div class="main">
    <div class="content">
      <slot />
    </div>
  </div>
</template>

<style lang="less" scoped>
.main {
  width: 100%;
  min-width: 1288px;
  max-width: 1488px;
  padding: 0 44px;
  margin: 0 auto;
}

.content {
  width: 100%;
  padding-bottom: 4em;
}
</style>
